import { Component, OnInit } from '@angular/core';
import { SideNavBarVisibilityService } from 'src/app/services/side-nav-bar-visibility.service';
import { Router } from '@angular/router';
import { ExcelService } from 'src/app/services/excel.service';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
  selector: 'app-lists',
  templateUrl: './lists.component.html',
  styleUrls: ['./lists.component.scss']
})
export class ListsComponent implements OnInit {

  public users: [];

  constructor(private router: Router, public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private excelService: ExcelService, public themeService: ThemeService) { }

  ngOnInit() {
  }

  exportAsXLSX(): void {
    this.excelService.exportAsExcelFile(this.users, 'Users');
  }

}
